// InventoryCustomizationHome.jsx
import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from "../components/HeaderBar";
import getCurrentSkin from "../utils/getCurrentSkin";
import { ThemeContext } from "../context/ThemeContext";
import AdminLayoutWrapper from "../components/AdminLayoutWrapper";
import { Settings, ArrowRight } from "lucide-react";

const InventoryCustomizationHome = () => {
  const navigate = useNavigate();

  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const buttonClass = useMemo(() => `bg-${baseColor}-${baseShade}`, [baseColor, baseShade]);
  const hoverClass = useMemo(() => `hover:bg-${baseColor}-700`, [baseColor]);

  const goAutoGRN = () => {
    // ASPX: Response.Redirect("AutoGRNSelect.aspx?id=GRN");
    // React route version:
    navigate("/adminMaster/AutoGRNSelect?id=GRN");
  };

  return (
    <AdminLayoutWrapper>
      <div className={`min-h-screen ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">Inventory Customization</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div
          className={`p-6 mt-6 rounded-2xl shadow-xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : "bg-white text-black border-gray-200"
          }`}
        >
          {/* Title box (like ASPX heading block) */}
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div className="flex items-center gap-3">
              <div
                className={`h-11 w-11 rounded-2xl flex items-center justify-center ring-1 ${
                  isDark ? "bg-white/10 ring-white/10" : "bg-gray-100 ring-gray-200"
                }`}
              >
                <Settings className="w-6 h-6" />
              </div>
              <div>
                <div className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
                  Inventory Customization
                </div>
                <div className={`text-sm ${isDark ? "text-white/60" : "text-gray-500"}`}>
                  Choose a customization module
                </div>
              </div>
            </div>
          </div>

          {/* Menu card */}
          <div className={`mt-6 rounded-2xl border overflow-hidden ${isDark ? "border-white/10" : "border-gray-200"}`}>
            <div className={`${isDark ? "bg-white/[0.06]" : "bg-gray-50"} px-5 py-4`}>
              <div className={`text-lg font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>
                Inventory Customization
              </div>
              <div className={`text-xs mt-1 ${isDark ? "text-white/60" : "text-gray-500"}`}>
                Available options
              </div>
            </div>

            <div className={`${isDark ? "bg-white/[0.03]" : "bg-white"} p-5`}>
              <button
                type="button"
                onClick={goAutoGRN}
                className={[
                  "w-full flex items-center justify-between gap-3 px-5 py-4 rounded-2xl",
                  "transition shadow hover:shadow-md ring-1",
                  isDark ? "ring-white/10 bg-white/[0.06] hover:bg-white/[0.09]" : "ring-gray-200 bg-gray-50 hover:bg-gray-100",
                ].join(" ")}
              >
                <div className="flex items-center gap-3">
                  <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${buttonClass} text-white`}>
                    <ArrowRight className="w-5 h-5" />
                  </div>
                  <div className="text-left">
                    <div className={`font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>Auto GRN</div>
                    <div className={`text-xs ${isDark ? "text-white/60" : "text-gray-500"}`}>
                      Open Auto GRN selection (id=GRN)
                    </div>
                  </div>
                </div>

                <div className={`px-4 py-2 rounded-xl font-semibold ${buttonClass} ${hoverClass} text-white`}>
                  Open
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayoutWrapper>
  );
};

export default InventoryCustomizationHome;
